import {useFormik} from "formik";
import ModalTemplate from "../../components/ModalTemplate/ModalTemplate";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import * as yup from "yup";
import Checkbox from "../../components/Checkbox/Checkbox";
import {userIcon} from "../../components/Icon/Icon";

const validationSchema = yup.object({
    id: yup.mixed().nullable(),
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    changePassword: yup.boolean(),

    password: yup.string().when(['id', 'changePassword'], {
        is: (id, changePassword) => !id || changePassword === true,
        then: (schema) => schema.required("Password is required"),
        otherwise: (schema) => schema.notRequired()
    }),

    confirmPassword: yup.string().when(['id', 'changePassword'], {
        is: (id, changePassword) => !id || changePassword === true,
        then: (schema) => schema
            .required("Confirm password is required")
            .oneOf([yup.ref('password')], "Passwords must match"),
        otherwise: (schema) => schema.notRequired()
    })
});

const UserModal = ({onClose, onSubmit, user}) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: user?.id || '',
            name: user?.name || '',
            surname: user?.surname || '',
            email: user?.email || '',
            role: user?.role || 'user',
            color: user?.color || '',
            changePassword: false,
            password: '',
            confirmPassword: '',
            image: user.image ?? null
        },
        validationSchema,
        onSubmit: onSubmit
    });


    const footerActions = (
        <>
            <Button type="submit" form="userModalForm" variant="primary">Save</Button>
            <Button type="button" onClick={onClose} variant="secondary">Cancel</Button>
        </>
    );

    return (
        <ModalTemplate
            onClose={onClose}
            title={user.id ? "Update user" : "Create user"}
            icon={userIcon}
            footerActions={footerActions}
        >
            <form
                id="userModalForm"
                onSubmit={formik.handleSubmit} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        formik.handleSubmit();
                    }
                }}
            >
                <Input
                    name="name"
                    label="Name"
                    className="modal"
                    formik={formik}
                />
                <Input
                    name="surname"
                    label="Surname"
                    required={false}
                    className="modal"
                    formik={formik}
                />
                <Input
                    name="color"
                    label="Color"
                    className="modal"
                    formik={formik}
                    type="color"
                />
                <Input
                    name="email"
                    label="Email"
                    className="modal"
                    formik={formik}
                />

                {!formik.values?.id ? (
                    <>
                        <Input
                            name="password"
                            type="password"
                            label="Password"
                            className="modal"
                            formik={formik}
                        />
                        <Input
                            name="confirmPassword"
                            type="password"
                            label="Confirm Password"
                            className="modal"
                            formik={formik}
                        />
                        <Input
                            name="image"
                            label="Profile Picture"
                            type="picture"
                            className="modal"
                            formik={formik}
                        />
                    </>
                ) : (
                    <>
                        <Input
                            name="image"
                            label="Profile Picture"
                            type="picture"
                            required={false}
                            className="modal"
                            formik={formik}
                        />
                        <Checkbox
                            name="changePassword"
                            label="Change Password"
                            checked={formik.values.changePassword}
                            formik={formik}
                        />
                        {formik.values.changePassword && (
                            <>
                                <Input
                                    name="password"
                                    type="password"
                                    label="Password"
                                    className="modal"
                                    formik={formik}
                                />
                                <Input
                                    name="confirmPassword"
                                    type="password"
                                    label="Confirm Password"
                                    className="modal"
                                    formik={formik}
                                />
                            </>
                        )}
                    </>
                )}

                {formik.values.role !== 'superadmin' && (
                    <Checkbox
                        label="Admin"
                        formik={formik}
                        onChange={(e) => formik.setFieldValue('role', e.target.checked ? "admin" : "user")}
                        checked={formik.values.role === 'admin'}
                    />
                )}
            </form>
        </ModalTemplate>
    );
};

export default UserModal;